// jQuery(document).ready(function() {
//     if (!is_dev) return;
//     view_entries();
// });

async function view_entries(givenElm= undefined, givenPopup = undefined, appointmentId = undefined) {
    const $ = jQuery.noConflict();

    const user = get_current_user();
    const hasELearning = user.modules.includes('e_learning');

    const columns = [{
        title: 'Datum/tijd',
        value: (row) => {
            return readable_date(row.created_at, 'DD-MM-YYYY HH:mm');
        }
    },{
        title: 'Persoon',
        value: (row) => {
            if (row.data.contact) {
                const prefix = row.data.contact.last_name_prefix ? row.data.contact.last_name_prefix : '';
                const value = `${row.data.contact.first_name} ${(prefix + ' ' + row.data.contact.last_name).trim()}`;
                const suggestion = row.suggestions.contact ? row.suggestions.contact : '-1';
                return `${value}<br />
                <select
                    name="entries[${row.id}][contact_id]"
                    data-with-empty
                    data-contact-selector
                    data-filter-key="entry-${row.id}-contact"
                    data-empty-string="Maak nieuw aan"
                    data-initial-value="${suggestion}"
                    data-current-value="${suggestion}"
                    data-contact-object="${Base64.encode(JSON.stringify([row.data.contact, row.data.company]))}"
                ></select>
                `;
            }
            return '';
        }
    }, {
        title: 'Bedrijf',
        value: (row) => {
            if (row.data.company) {
                const suggestion = row.suggestions.company ? row.suggestions.company : '-1';
                return `${(row.data.company.name ? row.data.company.name : `Debiteur: ${row.data.company.client_id ? row.data.company.client_id : '-'}`)}<br />
                <select
                    name="entries[${row.id}][company_id]"
                    data-with-empty
                    data-company-selector
                    data-filter-name="company_id"
                    data-entry-${row.id}-contact-filter
                    data-empty-string="Maak nieuw aan"
                    data-initial-value="${suggestion}"
                    data-current-value="${suggestion}"
                    data-company-object="${Base64.encode(JSON.stringify([row.data.company]))}"
                ></select>`;
            }
            return '';
        }
    }, {
        title: 'Planning',
        value: (row) => {
            if (row.appointments && row.appointments[0]) {
                const firstAppointment = row.appointments[0];
                const courseComponents = firstAppointment.course.components;
                const appliedToAllComponents = row.appointments.length === courseComponents.length;
                const componentNames = courseComponents
                    .filter((component) => {
                        return row.appointments
                            .map((appt) => appt.course_component_id)
                            .includes(component.id);
                    })
                    .map((component) => {
                        return component.description;
                    })
                    .join(', ');

                return `<a href="#" onclick="return view_appointment(${firstAppointment.id})">Planning #${firstAppointment.appointment_group_id}<br />Vrije plaatsen: ${firstAppointment.freeSpace}<br />${firstAppointment.course.description}<br />(${readable_date(firstAppointment.start_datetime, 'DD-MM-YYYY HH:mm')})</a><br />
                        ${appliedToAllComponents ? 'Alle onderdelen' : componentNames}`;
            }
            return '';
        }
    }];

    if (hasELearning) {
        columns.push({
            title: 'E-learning',
            value: (row) => {
                if (row.e_learning_course) {
                    const course = row.e_learning_course;
                    const expiryDays = course.expiry_days;
                    const now = moment();
                    const expiryDate = moment(now).add(expiryDays, 'days');

                    if (row.e_learning_license_access_url) {
                        return `<a href="${row.e_learning_license_access_url}" target="_blank">${course.description} ${now.format('DD-MM-YYYY')} - ${expiryDate.format('DD-MM-YYYY')}</a>`;
                    }

                    return `<a href="#" onclick="return view_elearning_course(${course.id})">${course.description} ${now.format('DD-MM-YYYY')} - ${expiryDate.format('DD-MM-YYYY')}</a>`;
                }
                return '';
            }
        });
    }

    const headings = columns
        .map((column) => {
            return `<th>${column.title}</th>`;
        })
        .join('');

    const body = $('body');
    body.isLoading('dark');
    const data = await $.getJSON('/api/entries', { appointmentId });
    body.doneLoading();


    const rows = data.map((row) => {
        return `<tr data-id="${row.id}">
            <td>
                <input type="hidden" name="entries[${row.id}][register]" value="0" />
                <input type="checkbox" name="entries[${row.id}][register]" value="1" checked />
                <div class="icon-container">
                    <span class="visual-icon-tick green"></span>
                    <span class="visual-icon-cross"></span>
                </div>
            </td>
            ${columns.map((column) => {
                return `<td>${column.value(row)}</td>`;
            }).join('')}
            <td class="status-column">
                ${row.status_description}
            </td>
            <td class="data-column">
                <div>
                    <pre>${JSON.stringify(row.data, null, 2)}</pre>
                </div>
            </td>
        </tr>`;
    }).join('');

    const html = $(`<div><h1>Registraties</h1>
        <p>Verwerk hier alle registraties${appointmentId ? ' voor de geselecteerde planning' : ''}, afkomstig van de API.</p>
        <form action="#">
            <table class="entries-table scrollable-table">
                <thead>
                    <th><input type="checkbox" onclick="checkWholeTable(this)" checked /></th>
                    ${headings}
                    <th>Status</th>
                    <th>Ontvangen data</th>
                </thead>
                <tbody>
                    ${rows}
                </tbody>
            </table>
            <div class="row send-messages-wrapper">
                <div class="column text-center">
                    <p class="callout warning">
                        <label for="send_message">
                            <input type="checkbox" id="send_message" value="1" checked /> Verstuur bevestigingsberichten
                        </label>
                    </p>
                </div>
            </div>
            <div class="button-wrapper text-center">
            
            </div>
        </form>
    </div>`);

    // html.

    const submitButton = $('<button class="button primary">Verwerken</button>');
    html.find('.button-wrapper').append(submitButton);

    const removeButton = $('<button class="button alert" type="reset">Verwijderen</button>');
    html.find('.button-wrapper').append(removeButton);

    const cancelButton = $('<button class="button secondary" type="reset">Sluiten</button>');
    html.find('.button-wrapper').append(cancelButton);

    const onOpenPopup = (elm, popup) => {
        elm.bind('reload-ajax-popup.entries', function() {
            $(this).unbind('reload-ajax-popup.entries');
            view_entries(elm, popup);
        });
        cancelButton.click(function() {
            popup.close();
            return false;
        });
        const table = elm.find('.entries-table');
        const form = table.parent();
        if (data.length === 0) {
            form.prev().html(`Er zijn geen registraties bekend in het systeem${appointmentId ? ' voor deze planning' : ''}.`);
            elm.find('.send-messages-wrapper').remove();
            table.remove();
            removeButton.remove();
            submitButton.remove();
            return;
        }
        table.find('input[type="checkbox"][value]').change(function() {
            const canSubmit = table.find('input[value]:checked:not(:disabled)').length > 0;
            if (canSubmit) {
                elm.find('.send-messages-wrapper').show();
                submitButton.removeAttr('disabled');
                removeButton.removeAttr('disabled');
            } else {
                elm.find('.send-messages-wrapper').hide();
                submitButton.attr('disabled', 'disabled');
                removeButton.attr('disabled', 'disabled');
            }
        });
        elm.find('[data-company-selector]').companySelector().change(function() {
            const companyId = $(this).val();
            const initial = $(this).attr('data-initial-value');
            const wasInitialCompany = companyId === initial;
            const contactSelector = $(this).parents('tr').find('[data-contact-selector]');
            let newContactValue = '-1';
            if (wasInitialCompany) {
                newContactValue = contactSelector.attr('data-initial-value');
            }
            $(this).parents('tr').find('[data-contact-selector]').setValue(newContactValue);

            setTimeout(() => {
                const uid = $(this).attr('data-uid');
                const value = $(this).val();
                const searchValue = $(this).prev().val();
                const companyObject = $(this).attr('data-company-object');
                const selectors = table.find(`[data-company-selector]:not([data-uid="${uid}"])[data-company-object="${companyObject}"]`);

                selectors.each(function() {
                    const select = $(this);
                    select.append(`<option value="${value}" selected>${value}</option>`);
                    select.attr('data-current-value', value);
                    select.val(value);
                    const search = select.prev();
                    search.val(searchValue);
                });
            }, 50);
        });
        elm.find('[data-contact-selector]').contactSelector().bind('change', function() {
            setTimeout(() => {
                const uid = $(this).attr('data-uid');
                const value = $(this).val();
                const searchValue = $(this).prev().val();
                const contactObject = $(this).attr('data-contact-object');
                const selectors = table.find(`[data-contact-selector]:not([data-uid="${uid}"])[data-contact-object="${contactObject}"]`);

                selectors.each(function() {
                    const select = $(this);
                    select.append(`<option value="${value}" selected>${value}</option>`);
                    select.attr('data-current-value', value);
                    select.val(value);
                    const search = select.prev();
                    search.val(searchValue);
                });
            }, 50);
        });

        removeButton.click(async function(e) {
            e.preventDefault();
            const data = form.serializeJSON().entries;
            const entriesToRemove = [];
            for (const id of Object.keys(data)) {
                if (parseInt(data[id].register) === 1) {
                    entriesToRemove.push(parseInt(id, 10));
                }
            }

            form.css('pointer-events', 'none');

            for(const entryId of entriesToRemove) {
                const tr = table.find(`tr[data-id="${entryId}"]`);
                tr.isLoading();
                try {
                    await $.post(`/api/entries/remove/${entryId}`);
                    tr.remove();
                } catch (e) {
                    squde_flash('Er ging iets mis', 'alert');
                }
            }

            const leftOverLength = table.find('tbody tr').length;
            jQuery('a[onclick="view_entries()"]').attr('notification-number', leftOverLength);

            if (leftOverLength === 0) {
                popup.close();
                await view_entries();
                return;
            }

            form.removeAttr('style');
        })

        form.submit(async (e) => {
            e.preventDefault();
            form.css('pointer-events', 'none');

            const counts = {
                success: 0,
                error: 0,
            }

            const data = form.serializeJSON().entries;
            for(const entryId of Object.keys(data)) {
                // Fetch form data again, since you could have changed it
                const row = _.get(form.serializeJSON().entries, entryId);
                const tr = table.find(`tr[data-id="${entryId}"]`);
                if (row.register !== '1') continue;

                tr.isLoading();

                try {
                    if (form.find('#send_message').is(':checked')) {
                        row.sendMessage = true;
                    }
                    const result = await $.post(`/api/entries/process/${entryId}`, row);

                    const { created } = result;
                    if (created.company) {
                        const companyObject = tr.find('[data-company-selector]').attr('data-company-object');
                        const selectors = table.find(`[data-company-selector][data-current-value="-1"][data-company-object="${companyObject}"]`);
                        const [id, name] = created.company;
                        selectors.each(function() {
                            const select = $(this);
                            select.append(`<option value="${id}" selected>${id}</option>`);
                            select.attr('data-current-value',id);
                            select.val(id);
                            const search = select.prev();
                            search.val(name);
                        });
                    }
                    if (created.contact) {
                        const contactObject = tr.find('[data-contact-selector]').attr('data-contact-object');
                        const selectors = table.find(`[data-contact-selector][data-current-value="-1"][data-contact-object="${contactObject}"]`);
                        const [id, name] = created.contact;
                        selectors.each(function() {
                            const select = $(this);
                            select.append(`<option value="${id}" selected>${id}</option>`);
                            select.attr('data-current-value',id);
                            select.val(id);
                            const search = select.prev();
                            search.val(name);
                        });
                    }

                    tr.find('[type="checkbox"]').attr('disabled', 'disabled');
                    counts.success++;
                    tr.addClass('done');
                } catch (e) {
                    console.error(e);
                    tr.addClass('error');
                    counts.error++;
                }
                tr.doneLoading();
            }
            form.removeAttr('style');
            table.find('input[type="checkbox"][value]:first').trigger('change');
            reload_location_if_needed(false);
            const leftOverLength = table.find('tbody tr').length - counts.success;
            jQuery('a[onclick="view_entries()"]').attr('notification-number', leftOverLength);

            const type = counts.error === 0 ? 'success' : 'alert';
            const message = type === 'alert' ? 'Er zijn fouten opgetreden' : 'Verwerken voltooid.';
            squde_flash(message, type);

            return false;
        });
    }

    if (!givenElm && !givenPopup) {
        foundationPopup(html, onOpenPopup)
    } else {
        givenElm.html(html);
        onOpenPopup(givenElm, givenPopup);
    }

    return false;

}
